import React, { Suspense } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./toastifyStyle.css";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
// Redux
import { Provider } from "react-redux";
import generateStore from "./redux/store";
// Components
import I18Next from "./i18n";

function App() {
  const store = generateStore();

  return (
    <Provider store={store}>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        limit={2}
        rtl={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Suspense fallback={<div>Loading...</div>}>
        <I18Next />
      </Suspense>
    </Provider>
  );
}

export default App;
